import type { ReactNode } from 'react'
import { useState } from 'react'
import { Button } from '@/shared/ui/button'
import { Dialog } from '@/shared/ui/dialog'
import { Field, Input } from '@/shared/ui/field'

interface ConfirmDialogProps {
  open: boolean
  title: string
  /** Контент-предупреждение: что именно произойдёт (каскад и т.п.). */
  children: ReactNode
  confirmLabel: string
  tone?: 'danger' | 'primary'
  /** Точная строка, которую нужно ввести, чтобы разблокировать подтверждение. */
  typeToConfirm?: string
  pending?: boolean
  onConfirm: () => void
  onClose: () => void
}

// Подтверждение необратимого действия. typeToConfirm — фрикцион для самых
// разрушительных операций (удаление компании): кнопка активна только после
// точного ввода названия.
export function ConfirmDialog(props: ConfirmDialogProps) {
  // Remount по open: свежее открытие не наследует ввод прошлой попытки.
  return <ConfirmDialogInner key={String(props.open)} {...props} />
}

function ConfirmDialogInner({
  open,
  title,
  children,
  confirmLabel,
  tone = 'danger',
  typeToConfirm,
  pending,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  const [typed, setTyped] = useState('')
  const blocked = typeToConfirm !== undefined && typed !== typeToConfirm

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={pending}>
            Отмена
          </Button>
          <Button
            variant={tone === 'danger' ? 'danger' : 'primary'}
            onClick={onConfirm}
            disabled={blocked || pending}
          >
            {pending ? 'Выполняем…' : confirmLabel}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        {children}
        {typeToConfirm !== undefined && (
          <Field label="Введите название для подтверждения">
            {(props) => (
              <Input
                {...props}
                value={typed}
                placeholder={typeToConfirm}
                disabled={pending}
                autoComplete="off"
                onChange={(e) => setTyped(e.target.value)}
              />
            )}
          </Field>
        )}
      </div>
    </Dialog>
  )
}
